import {
    FC,
    ReactElement,
    useEffect,
    useMemo,
} from 'react'

import { PzLogs } from '../../containers'
import { CONFIG_FILTERS_REQUEST_VALUE_MAP, NotificationCenterCategory } from '../../entities/NotificationCenter/NotificationCenter'
import { getCheckedFormOptionsValue } from '../../helpers/types/formOption'
import { fetchPzLogs, fetchPzLogsPagination } from '../../redux/pzLogs/pzLogsActions'
import { setPage } from '../../redux/pzLogs/pzLogsReducer'
import { useTypedDispatch, useTypedSelector } from '../../redux/store'
import { FormOption } from '../../types'

const ConnectedPzLogs: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()

    const { categories, categoryOptions } = useTypedSelector(state => state.pzLogCategoriesReducer)
    const {
        isLoading,
        isLoadingPagination,
        logs,
        page,
        search,
        totalPages,
    } = useTypedSelector(state => state.pzLogsReducer)

    const selectedCategoryIds = useMemo(() => getCheckedFormOptionsValue(categoryOptions), [categoryOptions])

    const handlePaginationChange = (value: number): void => {
        dispatch(setPage(value))
    }

    const getSelectedQueryValues = (options: FormOption[]): string[] => options
        .filter(opt => opt.isChecked)
        .flatMap(opt => CONFIG_FILTERS_REQUEST_VALUE_MAP[opt.value as NotificationCenterCategory] ?? [])

    useEffect((): void => {
        const queryValues = getSelectedQueryValues(categoryOptions)
        dispatch(fetchPzLogs(queryValues, search, page))
    }, [selectedCategoryIds.join(','), page, search])

    useEffect((): void => {
        dispatch(fetchPzLogsPagination(selectedCategoryIds, search, page))
    }, [selectedCategoryIds.join(','), search])

    return (
        <PzLogs
            isLoading={isLoading}
            isLoadingPagination={isLoadingPagination}
            categories={categories}
            logs={logs}
            page={page}
            totalPages={totalPages}
            onPaginationChange={handlePaginationChange}
        />
    )
}

export default ConnectedPzLogs
